export default __webpack_public_path__ + "static/media/JCB.de23f05c.svg";